module.exports = __webpack_public_path__ + "images/dingtalk-phone-dcd0bbee65adfe866a00364b06d7c549.png";